// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2142":"css/admin-app.6684","6283":"css/app.6684"}[chunkId] + ".css";
};